import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ModalMediumCenteredLoading } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import TwinForm from '../../../../../../../../forms/TwinForm'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { PaymentTypesPayload } from '../../../../../../../../utils/reducers/payments/paymentTypes'
import { ButtonDisabledOrLoader, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { PaymentMethodsPayload } from '../../../../../../../../utils/reducers/payments/paymentMethods'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { addDictionaryExtraLine, TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { payMCopyDateStatusInversed, PayMCopyDateStatusKeys } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import {  OrderPaymentMethodDataTy, PayMCopyDateModeAddExtended, PayMCopyModelTypeExt } from './types'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { changeErrorMessage } from '../../../../../../../../utils/reducers/reduxDispatch'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import useDictPaymentTypes from './useDictPaymentTypes'
import { PaymentRelatedTypesKeys } from '@teinor/erp/types/company/config/paymentType'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import NullComponent from '../../../../../../../../baseComponents/NullComponent'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import useGetDictPaymentBanks from '../../../../../../../../utils/hooks/payments/getDictPaymentBanks'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import { useNavigate } from 'react-router'
import { FooterTotalsResult } from '@teinor/erp/types/company/order/general'
import { SetCompleteDataTy } from '../../../../types'
import { ErrorTotalPaymentMethod } from './subcomponents'
import { returnClassOfSpanTemplate } from '../../../../../../../../utils/globals/tailwind'
import { getExactDateFromDays, getStartOfDay } from '../../../../../../../../utils/globals/date'
import { getQuantityToPayModalPayM, parsePaymentMethodDates, recalculateAllQuantitiesModalPayM } from '../../../../../../../../utils/globals/order/paymentDates'
import ModalTablePaymentMethodDates from './ModalTablePaymentMethodDates'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import './modalOrderPaymentMethod.sass'


type ModalOrderPaymentMethodProps = ModalOrderPaymentMethodLogicProps & ReduxModalOrderPaymentMethod & {
    setOpened: ModalOpenedSetTy
    isReadOnly?: boolean
}

const ModalOrderPaymentMethod: React.FC<ModalOrderPaymentMethodProps> = ({ headerData, paymentMethods, paymentTypes, setOpened, isReadOnly = false, ...logic}) => {
    const { t} = useTwinTranslation()
    const { handleSelectPaymentMethod, orderPaymentMethodData, checkAllOk, handleOnSubmit, paymentTypesMemo, dictPaymentTypes, loading, setOrderPaymentMethodData, recalculateAllQuantitiesFromBack, getPaymentMethodCopyComplete } = useModalOrderPaymentMethodLogic({ headerData, setOpened, paymentTypes, isReadOnly, ...logic })
    
    let isFinished = false
    if(headerData.status === sellInvoiceStatusInversed['accepted']){
        isFinished= true
    }
    const dictPaymentMethods = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentMethods?.active || {}))), [paymentMethods])
    const fields: FormRender<PayMCopyModelTypeExt> = [
        {
            cols: 3,
            elements: [
                {
                    name: 'PaymentMethodId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('typeMethod', 'Tipo de método'),
                    items: dictPaymentMethods,
                    value: orderPaymentMethodData?.selectedPaymentMethod || '',
                    onChange: handleSelectPaymentMethod,
                    sortItems: true,
                    readOnly: isReadOnly
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'InputHidden',
                    value: headerData?.BillingWorkingCenterId
                },
                {
                    name: 'CustomerId',
                    component: 'InputHidden',
                    value: headerData?.CustomerId
                },
                {
                    name: 'Customer',
                    component: 'Custom',
                    render: ({ value }) => <ErrorTotalPaymentMethod notMatchTotals={orderPaymentMethodData.errorTotalNotMatch} recalculateAllQuantity={recalculateAllQuantitiesFromBack} className={ returnClassOfSpanTemplate(2)} />,
                    extraProps: { orderPaymentMethodData }
                },
                {
                    name: 'name',
                    component: 'InputHidden',
                    value: dictPaymentMethods?.[orderPaymentMethodData?.selectedPaymentMethod|| '']?.name || ''
                },
                {
                    name: 'total_total',
                    component: 'InputHidden',
                    value: logic.totalsOrderTableData?.totals?.total || headerData?.total_total
                },
                {
                    name: 'SellInvoiceId',
                    component: 'InputHidden',
                    value: headerData?.id
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: headerData?.PayMCopyId
                },
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: headerData?.CurrencyId
                },
            ]
        }
    ]

    return (
        <ModalMediumCenteredLoading loading={dictPaymentTypes === null} className='modal_order_payment_method' opened={true} setOpened={()=>setOpened(null)} onClickOut={false}>
            <h2><TwinTrans transKey='configPaymentMethod'>Configurar métodos de pago</TwinTrans></h2>
            <TwinForm action={logic.allRowData?.url || ''} onSubmit={handleOnSubmit} className='mt-20 flex flex-auto flex-col notFlexAutoFormRender' beforeSubmitHandler={checkAllOk}>
                <FormRenderer sections={fields} />
                <h4 className='text-left my-20'><TwinTrans transKey='paymentDetails'>Detalle de los pagos</TwinTrans></h4>
                <ModalTablePaymentMethodDates total={logic.totalsOrderTableData.totals.total} {...{ orderPaymentMethodData, loading, isReadOnly, paymentTypesMemo, setOrderPaymentMethodData, dictPaymentTypes, headerData, isFinished, getPaymentMethodCopyComplete }} />
                <div className='flex items-center gap-x-10 justify-end mt-20'>
                    <ButtonSecondary onClick={() => setOpened(null)}>
                        <TwinTrans transKey='cancel'>Cancelar</TwinTrans>
                    </ButtonSecondary>
                    <ButtonDisabledOrLoader loading={loading} textButton={t('save', 'Guardar')} buttonIsDisabled={!orderPaymentMethodData.selectedPaymentMethod || isReadOnly || orderPaymentMethodData.errorTotalNotMatch}></ButtonDisabledOrLoader>
                </div>
            </TwinForm>
        </ModalMediumCenteredLoading>
    )
}


interface ModalOrderPaymentMethodLogicProps {
    headerData: TwinDictionary
    beforeSubmit?: (url: string, navigateUrl: string, extraProps?: TwinDictionary | undefined) => Promise<void>
    setOpened: ModalOpenedSetTy
    setCompleteData?: SetCompleteDataTy
    navigateUrl?: string
    paymentTypes: PaymentTypesPayload
    allRowData?: RowData
    isReadOnly?: boolean
    notMatchTotals?: boolean
    totalsOrderTableData: FooterTotalsResult
    onSubmit?: () => void
}

const useModalOrderPaymentMethodLogic = ({ headerData, setOpened, paymentTypes, totalsOrderTableData, setCompleteData, navigateUrl, allRowData, beforeSubmit, onSubmit, notMatchTotals = false, isReadOnly = false }: ModalOrderPaymentMethodLogicProps) => {
    const [orderPaymentMethodData, setOrderPaymentMethodData] = useState<OrderPaymentMethodDataTy>({ selectedPaymentMethod: headerData?.PayMCopy?.PaymentMethodId || headerData?.PaymentMethodId || null, paymentMethodDates: null, errorTotalNotMatch: notMatchTotals })
    const { dictPaymentBanks } = useGetDictPaymentBanks({ CustomerId: headerData.CustomerId, WorkingCenterId: headerData.BillingWorkingCenterId })
    const { dictPaymentTypes } = useDictPaymentTypes({ dictPaymentBanks })
    const {startLoading, endLoading, loading}= useIsLoading()
    const {t} = useTwinTranslation()
    const navigate = useNavigate()
    const completePaymentTypeErr = t('setAllPaymentTypes', 'Debes configurar todos los tipos de pago')
    const completeInfoPaymentErr = t('setAllPaymentInformation', 'Debes configurar toda la información de pago')
    const negativeQuantityErr = t('negativeQuantity', 'Tienes alguna cantidad negativa')
    const paymentTypesMemo = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(paymentTypes?.all || {}))), [paymentTypes?.all])
    const checkAllOk: BeforeSubmitHandler = useCallback((vals) => {
        const copyPaymentMethodDates = JSON.parse(JSON.stringify(orderPaymentMethodData.paymentMethodDates))
        copyPaymentMethodDates.splice(copyPaymentMethodDates.length-1, 1)
        for (const element of copyPaymentMethodDates) {
            if(parseFloat(String(element.quantity))<0){
                changeErrorMessage(negativeQuantityErr)
                return false
            }
            if(!element.PaymentTypeId){
                changeErrorMessage(completePaymentTypeErr)
                return false
            }
            const hasComponent  = dictPaymentTypes?.[paymentTypesMemo[element?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].component !== NullComponent
            if(hasComponent && !element.payment_data){
                changeErrorMessage(completeInfoPaymentErr)
                return false
            }
            if(element.payment_data){
                element.new_extra_payment_data = { 'value': element.payment_data}  
            }
            const extraProps = dictPaymentTypes?.[paymentTypesMemo[element?.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys].extraProps
            if(extraProps?.items){
                const payment_data = extraProps?.items?.[element.payment_data]
                element.new_extra_payment_data = {
                    iban: payment_data?.iban,
                    name: payment_data?.name,
                    id: payment_data?.id,
                }
            }
            element.date = getStartOfDay(element.date)
        }
        vals.paymentMethodInfo ={...vals, PaymentMethodId: orderPaymentMethodData.selectedPaymentMethod, paymentMethodDates: copyPaymentMethodDates }
        if (beforeSubmit){
            beforeSubmit(allRowData?.createUrl, allRowData?.navigateUrl, { paymentMethodInfo: vals.paymentMethodInfo, skipCheckOperateStock: true })
            return false
        }
        return true
    }, [orderPaymentMethodData.selectedPaymentMethod, orderPaymentMethodData.paymentMethodDates, completePaymentTypeErr, completeInfoPaymentErr, dictPaymentTypes, paymentTypesMemo, negativeQuantityErr, beforeSubmit, allRowData?.createUrl, allRowData?.navigateUrl])
    
    const handleOnSubmit: OnSubmit = useCallback(async(res, vals ) => {
        setOpened(null)
        if (res.status === 200) {
            const responseJSON = await res.json()
            if(navigateUrl){
                navigate(navigateUrl + '/' + responseJSON.id)
            }
            onSubmit?.()
            if(setCompleteData){
                const copyPaymentMethodDates = JSON.parse(JSON.stringify(orderPaymentMethodData.paymentMethodDates))
                copyPaymentMethodDates.splice(copyPaymentMethodDates.length - 1, 1)
                setCompleteData((old)=>{
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.header.PayMCopyId = responseJSON.id
                    copyOld.header.PayMCopy = { id: responseJSON.id, name: responseJSON.name, total_total: responseJSON.total_total, PaymentMethodId: vals.PaymentMethodId, PayMCopyDates: copyPaymentMethodDates }
                    return copyOld
                })
                setOrderPaymentMethodData((old)=>{
                    const copyOld = JSON.parse(JSON.stringify(old))
                    copyOld.paymentMethodDates = vals.paymentMethodInfo.paymentMethodDates
                    return copyOld
                })
            }
        }
    }, [setOpened, navigate, navigateUrl, setCompleteData, orderPaymentMethodData.paymentMethodDates, onSubmit])

    const getPaymentMethodCopyComplete = useCallback(async (PayMCopyId: number) => {
        startLoading()
        const response = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/getAllPaymentMethodCopyDateCompleteByParentId', { PayMCopyId })
        if (response) {
            setOrderPaymentMethodData((old)=>{
                const copyOld = JSON.parse(JSON.stringify(old))
                const { errorTotalNotMatch, paymentMethodDates } = parsePaymentMethodDates(response || [], totalsOrderTableData?.totals?.total, isReadOnly)
                return { ...copyOld, errorTotalNotMatch, paymentMethodDates }
            })
        }
        endLoading()
    }, [setOrderPaymentMethodData, startLoading, endLoading, totalsOrderTableData?.totals?.total,  isReadOnly])

    const handleSelectPaymentMethod = useCallback(async(value: number | null) => {
        let result: PayMCopyDateModeAddExtended[] | null = null
        if(value){
            const response = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/getPaymentMethodInstanceComplete', { id: value })
            if (response) {
                result = []
                let myTotalAccumulated = 0
                let myTotal = totalsOrderTableData?.totals?.total || headerData?.total_total || 0
                for (let i = 0; i < response?.PaymentMethodDates?.length ; i++) {
                    const element = response.PaymentMethodDates[i]
                    let isLast = false
                    if (i === response.PaymentMethodDates.length - 1) {
                        isLast = true
                    }
                    let myQuantity = 0
                    if (isLast) {
                        myQuantity = roundNumberAndDecimals(myTotal - myTotalAccumulated, totalCalculateParams)
                    } else {
                        myQuantity = roundNumberAndDecimals(getQuantityToPayModalPayM(parseFloat(String(myTotal)), element?.quantity || 0, element.type_quantity || 0), totalCalculateParams)
                    }
                    myTotalAccumulated = roundNumberAndDecimals(myTotalAccumulated + myQuantity, totalCalculateParams)
                    const paymentTypeData = dictPaymentTypes?.[paymentTypesMemo[element.PaymentTypeId]?.relatedType as PaymentRelatedTypesKeys]
                    result.push({
                        date: getExactDateFromDays(element?.day || 0) as any,
                        status: payMCopyDateStatusInversed['creating'] as PayMCopyDateStatusKeys,
                        quantity: myQuantity,
                        PaymentTypeId: element.PaymentTypeId,
                        payment_data: paymentTypeData?.extraProps?.value
                    })
                }
                result.push({ subId: 'addButton' })
            }
        }
        setOrderPaymentMethodData({
            selectedPaymentMethod: value,
            paymentMethodDates: result, 
            errorTotalNotMatch: false
        })
    }, [setOrderPaymentMethodData, totalsOrderTableData?.totals?.total, headerData?.total_total, dictPaymentTypes, paymentTypesMemo])

    const recalculateAllQuantitiesFromBack = useCallback(async() => {
        const response = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/getPaymentMethodInstanceComplete', { id: orderPaymentMethodData?.selectedPaymentMethod })
        if (response) {
            setOrderPaymentMethodData((old)=>{
                const copyOld = JSON.parse(JSON.stringify(old))
                let myTotal = totalsOrderTableData?.totals?.total || headerData?.total_total || 0
                recalculateAllQuantitiesModalPayM(myTotal, copyOld.paymentMethodDates, response.PaymentMethodDates)
                copyOld.errorTotalNotMatch = false
                return copyOld
            })
        }
    }, [setOrderPaymentMethodData, totalsOrderTableData?.totals?.total, headerData?.total_total, orderPaymentMethodData.selectedPaymentMethod])

    useEffect(() => {
        if (headerData?.PayMCopy?.PayMCopyDates?.length){
            getPaymentMethodCopyComplete(headerData?.PayMCopyId)
        } else if (headerData?.PayMCopy?.PaymentMethodId){
            handleSelectPaymentMethod(headerData?.PayMCopy?.PaymentMethodId)
        }
    }, [getPaymentMethodCopyComplete, headerData?.PayMCopyId, handleSelectPaymentMethod, headerData?.PayMCopy?.PaymentMethodId, headerData?.PayMCopy?.PayMCopyDates?.length])


    return { handleSelectPaymentMethod, orderPaymentMethodData, checkAllOk, handleOnSubmit, paymentTypesMemo, dictPaymentTypes, loading, setOrderPaymentMethodData, recalculateAllQuantitiesFromBack, getPaymentMethodCopyComplete }
}


const modalOrderPaymentMethodDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
    setPaymentMethods: (payload: PaymentMethodsPayload) => ({ type: 'CHANGE_PAYMENTMETHODS', payload }),
}

type ReduxModalOrderPaymentMethod = ConnectedProps<typeof modalOrderPaymentMethodConnect>
const mapModalOrderPaymentMethodConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes, paymentMethods: state.paymentMethods })
const modalOrderPaymentMethodConnect = connect(mapModalOrderPaymentMethodConnector, modalOrderPaymentMethodDispatch)
const taskConnectLoading = withLoading(ModalOrderPaymentMethod, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }, { fetchUrl: '/api/app/config/payment/paymentMethod/getAllPaymentMethods', propName: 'paymentMethods', setFunctionName: 'setPaymentMethods' }])
const ModalOrderPaymentMethodConnect = modalOrderPaymentMethodConnect(taskConnectLoading)
export default ModalOrderPaymentMethodConnect